import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import EventListForm from '@src/features/tenant/event/EventListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function EventList() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <EventListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default EventList;
